// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M18 20a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM6 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM18 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 10a4 4 0 0 0-3 1.38l-5.09-2.54a4 4 0 0 0 0-1.68L15 8.62a3.93 3.93 0 1 0-.91-1.78L9 9.38a4 4 0 1 0-.46 5.64l.02-.02c.14-.12.28-.26.4-.4l5.09 2.54A4 4 0 1 0 18 14Z"
      className={rtlFlipCss}
    />
  </BaseIcon>
)
